import { USStates } from './USStates.model'
import { Review } from './Review.model'
import { ClaimStatusTypes } from './ClaimStatus.model'

export type Hospital = {
  id: number
  stableId: string | null
  name: string
  imageURL: string | null
  permalink: string
  latitude: number | null
  longitude: number | null
  address: string | null
  city: string | null
  state: USStates
  zipcode: string | null
  website: string | null
  supportTelephone: string | null
  supportEmail: string | null
  externalId: string | null
  claimStatus: ClaimStatusTypes
  facilityCode: string | null
  averageRating: number
  reviewCount: number
  updatedAt: string
  createdAt: string
  reviews?: Review[]
  submissionNotes?: string | null
  submittedByEmail?: string | null
}

// we offer this to enable the enumerate the Hospital type's fields in js/ts files
export const hospitalFields: (keyof Hospital)[] = [
  'id',
  'stableId',
  'name',
  'imageURL',
  'permalink',
  'latitude',
  'longitude',
  'address',
  'city',
  'state',
  'zipcode',
  'website',
  'supportTelephone',
  'supportEmail',
  'externalId',
  'facilityCode',
  'averageRating',
  'reviewCount',
  'updatedAt',
  'createdAt',
  'submissionNotes',
  'submittedByEmail',
]
